import { Information } from "./components/Information";
import { Schedules } from "./components/Schedules";
import { NavBar } from "../../components/NavBar";
import { Configuration } from "./components/Configuration";
import { AiOutlineSetting } from "react-icons/ai";
import { FiClock, FiHome, FiSliders } from "react-icons/fi";
import "./style.css";
import "../admin.css";

export function CompanyPage() {
  return (
    <>
      <NavBar>
        <main className="admin-page company-page">
          <header className="admin-page-header"><div><h1>Meus dados</h1><p>Gerencie o estabelecimento, horários e experiência do seu cardápio</p></div><AiOutlineSetting size={21} /></header>

          <section className="admin-surface company-workspace">
          <ul className="nav company-tabs" id="company-tabs" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" id="company-information-tab" data-bs-toggle="tab" data-bs-target="#company-information" type="button" role="tab" aria-controls="company-information" aria-selected="true"><FiHome /> Estabelecimento</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="company-schedules-tab" data-bs-toggle="tab" data-bs-target="#company-schedules" type="button" role="tab" aria-controls="company-schedules" aria-selected="false"><FiClock /> Horários</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="company-configuration-tab" data-bs-toggle="tab" data-bs-target="#company-configuration" type="button" role="tab" aria-controls="company-configuration" aria-selected="false"><FiSliders /> Personalização</button>
            </li>
          </ul>

          <div className="tab-content" id="company-tabs-content">
            <div className="tab-pane fade show active" id="company-information" role="tabpanel" aria-labelledby="company-information-tab">
              <Information />
            </div>
            <div className="tab-pane fade" id="company-schedules" role="tabpanel" aria-labelledby="company-schedules-tab">
              <Schedules />
            </div>
            <div className="tab-pane fade" id="company-configuration" role="tabpanel" aria-labelledby="company-configuration-tab">
              <Configuration />
            </div>
          </div>
          </section>
        </main>
      </NavBar>
    </>
  )
}
